import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { SidebarService } from '../../../core/services/sidebar.service';
import { UserService } from '../../../core/services/user.service';
import { isCruOnboardingComplete } from '../../../core/utils';
import { NotificationDotComponent } from '../../../ui-kit/notification-dot/notification-dot.component';

interface SidebarButtonConfig {
  text: string;
  link: string | null;
  icon?: string;
  iconSrc?: string;
}

interface SidebarButtonMapping {
  [key: string]: SidebarButtonConfig;
}

@Component({
  selector: 'app-sidebar-button',
  templateUrl: './sidebar-button.component.html',
  styleUrls: ['./sidebar-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, MatIconModule, NotificationDotComponent],
})
export class SidebarButtonComponent implements OnInit {
  private sidebarService = inject(SidebarService);
  private userService = inject(UserService);

  @Input({ required: true }) name:
    | 'home'
    | 'projects'
    | 'financing'
    | 'project-compliance'
    | 'cru'
    | 'tools'
    | 'integrations'
    | 'account';
  @Input() selected = false;
  notificationDotVisible = false;

  buttonMapping: SidebarButtonMapping = {
    home: {
      iconSrc: '/assets/nav/home.svg',
      text: 'Home',
      link: '/homepage',
    },
    projects: {
      iconSrc: '/assets/nav/projects.svg',
      text: 'Projects',
      link: '/projects',
    },
    financing: {
      iconSrc: '/assets/nav/funding.svg',
      text: 'Financing',
      link: '/early-pay/requests',
    },
    'project-compliance': {
      iconSrc: '/assets/nav/compliance.svg',
      text: 'Compliance',
      link: '/contracts/contracts-page/my-contracts',
    },
    cru: {
      iconSrc: '/assets/nav/cru.svg',
      text: 'Accounting',
      link: '/cfo/cashflow',
    },
    tools: {
      icon: 'construction',
      text: 'Tools',
      link: '/projects',
    },
    integrations: {
      iconSrc: '/assets/nav/integrations.svg',
      text: 'Integrations',
      link: '/user/integrations',
    },
    account: {
      iconSrc: '/assets/nav/account.svg',
      text: 'Account',
      link: null,
    },
  };

  ngOnInit(): void {
    this.notificationDotVisible = this.sidebarService.isNotificationDotVisible(this.name);
    if (this.name === 'financing') {
      this.buttonMapping.financing.link = this.sidebarService.getFinancingDefaultLink();
    }
    if (this.name === 'cru') {
      const onboardingComplete = isCruOnboardingComplete(this.userService.getUser());
      this.buttonMapping.cru.link = onboardingComplete ? '/cfo/cashflow' : '/cfo/onboarding';
    }
  }
}
